import React from 'react';

import './ExpensesFilter.css';

const ExpensesFilter = (props) => {
   const dropdownChangeHandler=(event)=>            //event bta rha h kya change hua h...konsa year change hua h
   {
          props.onChangeFilter(event.target.value);   //ye method h to find value
                                                      //ab ye onChnageFilter name ke fn ko apne
                                                      //parent ke paas search karega
                                                      //aur vha pe year ki value ko send kardega as a parameter
   };
// line no 18----> it acts as an event listner when the user selects an year from drop down menu.
  return (
    <div className='expenses-filter'>
      <div className='expenses-filter__control'>
        <label>Filter by year</label> 
        
        <select onChange ={dropdownChangeHandler}>   
          <option value='2022'>2022</option>   
          <option value='2021'>2021</option>
          <option value='2020'>2020</option>
          <option value='2019'>2019</option>
        </select>
      </div>
    </div>
  );// when the user selects a year from dropdown on selection a function is triggered
  //dropdownChangeHandler 
};

export default ExpensesFilter;